import React from 'react';

import Footer from '../../Footer/Footer';
import './PageWithFooter.global.styl';

interface Props {
  children: React.ReactNode;
  className: string;
}

function PageWithFooter({ children, className }: Props) {
  return (
    <div className={`mio-page-with-footer ${className}`}>
      <div className="mio-page-with-footer__content">{children}</div>
      <Footer />
    </div>
  );
}

PageWithFooter.defaultProps = {
  children: undefined,
  className: '',
} as Partial<Props>;

export default PageWithFooter;
